import Slider from 'react-slick'
import { moment_date, handleUrlArticle } from 'Helpers/utils'
// import Image from 'next/image'
import ImageFallback from 'Components/imagefallback'
import vars from 'Consts/vars'

const BannerHomeMobile = (props) => {
  const ArrowLeft = () => null,
    ArrowRight = () => null,
    slider_settings = {
      arrow: false,
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <ArrowRight />,
      prevArrow: <ArrowLeft />,
      adaptiveHeight: true,
    }
  return (
    <div className="homepage-article-slider">
      <Slider {...slider_settings}>
        {Array.isArray(props.sponsoredPost)
          ? props.sponsoredPost.length
            ? props.sponsoredPost.map((item, id) => (
                <div className="homepage-banner" key={id}>
                  <div className="homepage-banner-img">
                    <a href={handleUrlArticle(item.url)} rel="noreferrer">
                      <div
                        style={{
                          width: '100%',
                          height: '100%',
                          position: 'relative',
                        }}
                      >
                        <ImageFallback
                          src={item.image}
                          alt={item.title}
                          objectFit="cover"
                          layout="fill"
                          priority
                          quality={80}
                          fallbackSrc={vars.imageBrokenDefault.square}
                        />
                      </div>
                    </a>
                  </div>
                  <div className="homepage-banner-content">
                    <div className="homepage-banner-inner-content">
                      <a href={handleUrlArticle(item.url)} rel="noreferrer">
                        <h4 className="homepage-banner-title-content">
                          {item.title}
                        </h4>
                      </a>
                      <p className="homepage-banner-timestamp">
                        by&nbsp;
                        <a
                          href={`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/blog/author/${item.author.username}`}
                        >
                          <span className="author-name">
                            {item.author.name}
                          </span>
                        </a>
                        &nbsp;&#8212;{' '}
                        <b>{moment_date({ date: item.created_at })}</b>
                      </p>
                    </div>
                  </div>
                </div>
              ))
            : null
          : null}
      </Slider>
      <style jsx>
        {`
          .author-name {
            font-weight: bold;
            color: var(--text-accent);
          }
          .homepage-banner {
            padding: 0;
            overflow-x: hidden;
            position: relative;
          }

          .homepage-banner-img {
            height: 200px;
            width: 100%;
            z-index: 1;
          }

          .homepage-banner-img a {
            text-decoration: none;
            height: 100%;
            display: block;
          }

          .homepage-banner-img a img {
            object-fit: cover;
            object-position: 50% 50%;
            height: 200px;
            max-width: unset;
            width: 100%;
          }

          .homepage-banner-content {
            background: #ffffff;
            height: fit-content;
            padding: 8px;
            z-index: 1;
            margin: auto;
          }

          .homepage-banner-inner-content {
            display: flex;
            flex-direction: column;
            align-items: center;
            border: 1px solid #dfe3e8;
            padding: 16px 11px;
          }

          .homepage-banner-title-content {
            font-family: Josefin Sans, sans-serif;
            font-size: 20px;
            font-style: normal;
            font-weight: 600;
            line-height: 26px;
            letter-spacing: -0.05em;
            text-align: center;
            color: #000000;
            margin: 0 0 12px 0;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }

          .homepage-banner-title-content:hover {
            color: #db284e;
          }

          .homepage-banner-timestamp {
            font-family: Roboto;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 10px;
            letter-spacing: 0px;
            text-align: center;
            color: #637381;
            margin: 0 0 24px 0;
          }

          .homepage-banner-timestamp b,
          .homepage-banner-timestamp i {
            font-weight: bold;
          }

          {
            /* slider custom styles */
          }

          .homepage-article-slider .slick-slider {
            max-width: 100vw;
          }

          .homepage-article-slider .slick-list {
            transition: all 0.2s ease;
          }

          .homepage-article-slider .slick-prev,
          .homepage-article-slider .slick-next {
            width: 22px;
            height: 22px;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.5);
            box-shadow: 0px 3px 10px rgba(145, 158, 171, 0.2);
            top: unset;
            z-index: 1;
            bottom: -25px;
          }

          .homepage-article-slider .slick-prev {
            left: 12px;
          }

          .homepage-article-slider .slick-prev::before {
            content: '❮';
          }

          .homepage-article-slider .slick-next {
            right: 12px;
          }

          .homepage-article-slider .slick-next::before {
            content: '❯';
          }

          .homepage-article-slider .slick-prev::before,
          .homepage-article-slider .slick-next::before {
            position: absolute;
            transform: translate(-3.5px, -7px);
            font-size: 12px;
            color: #000;
          }

          .homepage-article-slider .slick-dots {
            bottom: -10px;
          }

          .homepage-article-slider .slick-dots li,
          .homepage-article-slider .slick-dots li button,
          .homepage-article-slider .slick-dots li button::before {
            width: 10px;
            height: 10px;
          }

          .homepage-article-slider .slick-dots li {
            margin: 0 4px;
          }

          .homepage-article-slider .slick-dots li button {
            padding: 0;
          }

          .homepage-article-slider .slick-dots li button:before {
            font-size: 10px;
            line-height: 10px;
            color: #dfe3e8;
          }
        `}
      </style>
    </div>
  )
}

export default BannerHomeMobile
